import { createFileRoute } from "@tanstack/react-router";
import { CockpitModuleGate } from "@/components/cockpit/CockpitModuleGate";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { CockpitPageShell } from "@/components/cockpit/CockpitPageShell";
import { WahlkalenderChangeReportForm } from "@/components/cockpit/WahlkalenderChangeReportForm";
import { WahlkalenderTable } from "@/components/cockpit/WahlkalenderTable";

/** Ticket WK6: alle Gemeinden der freigeschalteten Bundesländer. */
export const Route = createFileRoute("/_cockpit/cockpit/wahlkalender")({
  head: () => ({
    meta: [
      { title: "Wahlkalender – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <CockpitModuleGate module="wahlkalender">
      <CockpitPageShell>
        <CockpitPageHeader
          title="Wahlkalender"
          description="Alle Gemeinden mit dem geltenden Wahldatum. Markieren Sie eine Gemeinde, um zwölf und sechs Monate vor der Wahl erinnert zu werden."
        />
        {/* Ticket WK29: Meldeweg prominent über der Liste. */}
        <WahlkalenderChangeReportForm />
        <WahlkalenderTable />
      </CockpitPageShell>
    </CockpitModuleGate>
  ),
});
